import { nip19 } from 'nostr-tools';
import { useParams } from 'react-router-dom';
import NotFound from './NotFound';
import { ProfilePage } from './ProfilePage';
import { EventDetailPage } from './EventDetailPage';
import { LivestreamDetailPage } from './LivestreamDetailPage';

/**
 * Renders any NIP-19 identifier. Mounted inside the shared AppLayout route,
 * so MainLayout stays put while the identifier (and page) changes.
 */
export function NIP19Page() {
  const { nip19: identifier } = useParams<{ nip19: string }>();

  if (!identifier) {
    return <NotFound />;
  }

  let decoded;
  try {
    decoded = nip19.decode(identifier);
  } catch {
    return <NotFound />;
  }

  const { type } = decoded;

  switch (type) {
    case 'npub':
    case 'nprofile': {
      const pubkey = type === 'npub' ? decoded.data : decoded.data.pubkey;
      return <ProfilePage pubkey={pubkey} />;
    }

    case 'note': {
      return <EventDetailPage eventId={decoded.data} />;
    }

    case 'nevent': {
      return (
        <EventDetailPage
          eventId={decoded.data.id}
          pubkey={decoded.data.author}
          relays={decoded.data.relays}
        />
      );
    }

    case 'naddr': {
      const { kind, pubkey, identifier: dTag } = decoded.data;
      // Kind 30311 = NIP-53 livestream — dedicated page with player + live chat
      if (kind === 30311) {
        return <LivestreamDetailPage pubkey={pubkey} dTag={dTag} relays={decoded.data.relays} />;
      }
      // All other addressable events (articles, etc.)
      return (
        <EventDetailPage
          eventId={dTag}
          pubkey={pubkey}
          kind={kind}
          relays={decoded.data.relays}
        />
      );
    }

    default:
      return <NotFound />;
  }
}
